<template>
  <div>
    <section class="contact-block">
        <b-container>
          <b-row align-h="center">
            <b-col cols="12" xl="10" class="d-flex flex-column">
              <form class="contact-block__form" v-if="!formSent" @submit="handleFormSubmit">
                <svg class="shape-1" width="362" height="474" viewBox="0 0 362 474" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M107.578 71.9235C108.091 71.4013 108.555 71.0348 109.018 70.6682C115.088 65.2302 126.376 63.0002 126.376 63.0002L174.951 52.5989L233.072 40.1802C239.957 38.709 247.108 40.9663 251.901 46.1234L340.219 141.153L218.795 167.932C210.057 169.775 199.789 176.961 196.909 185.989C196.86 186.144 196.016 188.79 194.526 193.46L196.016 188.79C198.995 179.451 196.108 165.669 189.413 158.389L117.843 80.5137C117.312 80.0016 116.939 79.5397 116.674 79.2837C116.144 78.7716 115.564 78.4151 115.034 77.903C114.454 77.5466 113.874 77.1901 113.294 76.8337L113.137 76.7835C112.665 76.6329 112.085 76.2764 111.563 76.2815C111.091 76.1309 110.461 75.9301 109.939 75.9351C109.782 75.8849 109.575 75.9904 109.418 75.9401C109.053 75.9954 108.738 75.895 108.374 75.9503C108.167 76.0557 107.803 76.111 107.645 76.0608C107.281 76.116 106.916 76.1713 106.502 76.3822C106.295 76.4876 106.088 76.5931 105.724 76.6483C105.517 76.7538 105.31 76.8592 105.103 76.9647C104.639 77.3313 104.175 77.6978 103.712 78.0644C103.455 78.3255 103.198 78.5866 102.892 79.0033C102.635 79.2644 102.586 79.4201 102.329 79.6812L102.279 79.8368C101.923 80.4092 101.518 81.1373 101.112 81.8654C102.925 77.8134 105.06 74.3789 107.578 71.9235Z" fill="#F6B09D"/>
                  <path d="M101.773 81.4173C101.624 81.8853 101.318 82.3032 101.119 82.9272C101.524 82.1973 101.93 81.4673 102.286 80.8934L102.336 80.7374C102.592 80.4754 102.642 80.3194 102.899 80.0575C103.155 79.7955 103.461 79.3776 103.718 79.1156C104.181 78.7477 104.644 78.3799 105.107 78.012C105.314 77.9061 105.521 77.8001 105.727 77.6942C105.934 77.5882 106.141 77.4823 106.505 77.4264C106.868 77.3705 107.282 77.1587 107.645 77.1028C107.852 76.9969 108.216 76.941 108.373 76.9911C108.737 76.9352 109.1 76.8793 109.414 76.9794C109.571 77.0295 109.778 76.9236 109.935 76.9736C110.455 76.9678 110.926 77.118 111.554 77.3183C112.025 77.4685 112.496 77.6187 113.124 77.8189L113.281 77.869C113.859 78.2253 114.487 78.4255 115.015 78.9378C115.593 79.294 116.122 79.8063 116.65 80.3186C116.914 80.5747 117.335 80.8809 117.814 81.5492L189.114 159.463C195.783 166.746 198.693 180.393 195.658 189.909L194.165 194.59L120.921 424.228C117.935 433.588 110.256 435.435 103.429 428.102L31.9724 350.138C25.303 342.855 22.2356 329.157 25.2709 319.641L100.058 85.1672C100.663 83.8132 101.218 82.6152 101.773 81.4173Z" fill="#983628"/>
                  <path d="M121.184 424C121.184 424 196.926 187.075 197.069 186.087C199.961 177.02 210.212 169.785 218.924 167.914L340.002 140.745L318.713 207.492L309.39 236.878L269.83 361.568L254.111 411.116C254.111 411.116 131.729 438.041 130.689 438.054C130.689 438.054 118.749 439.757 106.345 430.462C112.594 434.693 118.592 432.129 121.184 424Z" fill="#FF4337"/>
                </svg>
                <svg class="shape-2" width="438" height="386" viewBox="0 0 438 386" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M293.793 185.587C305.831 188.74 317.86 189.182 329.749 190.282C355.344 192.645 380.94 195.493 406.723 195.002C411.942 194.898 416.938 195.822 421.627 198.287C432.596 204.04 438.709 216.115 436.881 228.561C435.08 240.692 425.386 250.655 413.11 252.524C408.886 253.167 404.574 253.096 400.291 253.197C375.359 253.799 350.642 250.919 325.844 249.038C324.17 248.902 322.439 248.879 320.795 249.113C320.426 249.172 319.751 250.829 319.979 251.085C322.001 253.274 324.108 255.407 326.356 257.424C339.787 269.474 353.275 281.465 366.706 293.515C369.268 295.816 371.8 298.175 373.994 300.792C382.483 311.033 383.241 324.753 376.103 335.649C369.36 345.943 356.782 350.724 344.546 347.657C338.583 346.166 333.523 343.046 328.97 338.954C306.603 318.834 284.293 298.656 261.841 278.622C254.784 272.342 247.332 266.52 239.992 260.583C238.74 259.56 237.119 258.14 235.479 259.686C234.716 260.402 234.38 261.915 234.356 263.056C234.172 275.125 233.959 287.194 234.031 299.291C234.137 321.486 229.817 342.985 223.878 364.203C222.842 367.887 221.408 371.63 219.377 374.832C209.899 389.645 188.907 389.376 179.55 374.488C176.755 370.048 175.064 365.175 174.903 359.869C174.682 353.393 174.403 346.947 174.551 340.47C174.993 321.068 175.662 301.665 176.217 282.263C176.292 279.267 176.252 276.243 176.1 273.219C176.009 271.451 173.792 270.261 172.292 271.179C169.376 272.987 166.518 274.908 163.688 276.83C146.003 289.017 128.203 301.034 109.69 311.913C104.51 314.955 99.2726 317.941 93.8065 320.357C82.3929 325.418 70.4512 325.518 58.4992 322.735C54.837 321.893 51.1432 320.137 48.0719 317.951C34.8199 308.497 35.6041 289.608 49.4165 281.057C53.096 278.79 57.1473 277.378 61.3992 276.535C66.1047 275.606 70.3526 273.594 74.2002 270.727C94.1171 255.792 114.034 240.829 133.922 225.809C134.488 225.379 134.569 224.324 134.879 223.552C133.31 221.047 130.474 221.285 128.146 220.837C99.9034 215.602 71.6611 210.509 43.3907 205.474C39.6157 204.803 35.6731 204.902 31.898 204.231C27.2716 203.448 22.5035 202.723 18.1578 201.113C7.5633 197.156 0.975773 187.279 0.851512 176.21C0.725133 164.542 7.58289 154.589 18.7727 150.413C24.0419 148.454 29.5423 147.721 35.1576 147.388C48.9973 146.569 62.5075 148.832 75.9903 151.352C86.8901 153.396 97.818 155.354 108.689 157.341C109.612 153.544 107.082 152.155 105.403 150.42C89.5165 134.072 73.6305 117.723 57.6596 101.461C50.4 94.04 44.1305 85.8741 38.7946 76.9631C35.6272 71.6678 34.0184 65.939 34.2234 59.7187C34.7835 41.6573 52.7319 31.5513 68.2808 40.7685C72.3172 43.1507 75.9308 46.3048 79.431 49.4592C101.513 69.2379 123.595 89.0736 145.536 109.024C156.378 118.857 167.588 128.204 179.192 137.092C180.216 137.859 181.268 138.597 182.377 139.278C184.794 140.782 186.748 139.976 186.852 137.351C186.982 133.898 186.941 130.446 186.957 126.994C186.867 101.546 186.919 76.0967 186.63 50.6491C186.543 41.9192 187.619 33.4135 189.547 25.0189C192.005 14.3115 198.075 6.15899 208.642 2.32713C228.133 -4.76018 249.204 10.0579 247.008 30.7499C243.548 63.0865 246.102 95.3733 245.252 127.672C245.203 129.841 245.154 131.98 245.275 134.148C245.484 137.058 244.107 140.885 246.808 142.559C249.935 144.517 252.135 140.857 254.313 139.138C275.246 122.659 296.036 106.009 315.999 88.3073C320.835 84.0393 325.642 79.7428 330.592 75.6169C333.222 73.4394 335.994 71.2613 338.995 69.7101C350.972 63.5338 364.481 65.3975 373.59 74.2666C382.47 82.9082 385.329 97.2487 380.577 108.934C377.371 116.791 372.317 123.485 364.927 127.192C355.526 131.875 347.977 138.835 339.972 145.254C325.546 156.802 311.263 168.55 296.951 180.241C295.678 181.301 294.064 182.191 293.792 185.53L293.793 185.587Z" fill="#007CC2"/>
                </svg>
                <div class="d-flex flex-column">
                  <h3 class="contact-block__title" v-html="payload.title"></h3>
                  <div class="contact-block__text" v-html="payload.content"></div>
                  <b-col class="contact-block__form-wrapper" cols="12" xl="7">
                    <label class="contact-block__label">
                      <p class="contact-block__label-text">Imię i nazwisko<span class="star-red">*</span></p>
                      <b-input req v-model="form.first_name" type="text" required class="contact-block__input"/>
                      <p v-if="errors.first_name" class="error-message">{{ errors.first_name  }}</p>
                    </label>
                    <label class="contact-block__label">
                      <p class="contact-block__label-text">Adres e-mail<span class="star-red">*</span></p>
                      <b-input req v-model="form.email" type="email" required class="contact-block__input"/>
                      <p v-if="errors.email" class="error-message">{{ errors.email  }}</p>
                    </label>
                    <label class="contact-block__label">
                      <p class="contact-block__label-text">Numer telefonu</p>
                      <b-input req v-model="form.phone" type="tel" class="contact-block__input"/>
                      <p v-if="errors.phone" class="error-message">{{ errors.phone }}</p>
                    </label>
                    <label class="contact-block__label contact-block__label--check d-flex align-items-center">
                      <input type="checkbox" name="consent" class="label" required v-model="form.consent" />
                      <p class="contact-block__label--check-text mt-1">Wyrażam zgodę na przetwarzanie moich danych osobowych w celu komunikacji.</p>
                    </label>
                    <p v-if="errors.consent" class="error-message">{{ errors.consent }}</p>
                  </b-col>
                  <div class="d-flex justify-content-center">
                    <b-button variant="secondary" class="contact-block__button" type="submit">
                      Wyślij
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12.5L5 12.5M19 12.5L13 18.5M19 12.5L13 6.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </b-button>
                  </div>
                </div>
              </form>
              <div class="form-success" v-if="formSent && !formSentError">
                <p>Dziękujemy za kontakt, postaramy się odpowiedzieć tak szybko jak to możliwe.</p>
              </div>
              <div class="form-error" v-if="formSent && formSentError">
                <p>Ups.. Coś poszło nie tak. Spróbuj ponownie za chwilę.</p>
              </div>
            </b-col>
          </b-row>
        </b-container>
    </section>
  </div>
</template>

<script>
import wp_api_client from "@/store/wp_api_client";
const api = new wp_api_client(process.env.VUE_APP_API_URL)

export default {
      name: "Contact",
      components: {},
      props: ['payload'],
      data(){
        return {
          form: {
            first_name: null,
            last_name: null,
            email: null,
            phone: null,
            consent: false,
          },
          formSent: false,
          formSentError: false,
          errors: {
            phone: null,
            first_name: null,
            email: null,
            consent: null
          }
        }
      },
      methods: {
        handleFormSubmit(e) {
          e.preventDefault();
          this.resetErrors();

          let isValid = true;

          const phoneRegex = /^[0-9]+$/;
          if (this.form.phone && !phoneRegex.test(this.form.phone)) {
            this.errors.phone = 'Numer telefonu może zawierać tylko cyfry.';
            isValid = false;
          }

          if (!this.form.first_name || this.form.first_name.length < 2) {
            this.errors.first_name = 'To pole jest wymagane';
            isValid = false;
          }

          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(this.form.email)) {
            this.errors.email = 'Proszę podać prawidłowy adres e-mail.';
            isValid = false;
          }

          if (!this.form.consent) {
            this.errors.consent = 'Proszę wyrazić zgodę na przetwarzanie danych osobowych.';
            isValid = false;
          }

          if (!isValid) {
            return;
          }

          api.sendContactForm(this.form)
            .then((res) => {
              if(res.status === 200) {
                this.formSent = true;
                this.formSentError = false;
                this.resetErrors();
              } else {
                this.formSentError = true;
              }
            })
        },
        resetErrors() {
          this.errors.phone = null;
          this.errors.first_name = null;
          this.errors.email = null;
          this.errors.consent = null;
        }
      }
    }
</script>

<style lang="scss">
    .contact-block {
      position: relative;
      background: $main-bg;
      color: $main-color;
      padding-top: 70px;
      padding-bottom: 70px;
      z-index: 0;

      & .error-message {
        font-size: .88em;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 0;
        margin-left: 8px;
        color: #FF4337;
        margin-top: 4px;
      }
    }
    .contact-block__form {
      position: relative;
      background-color: $white;
      padding: 64px;
      border-radius: 20px;

      @include media-breakpoint-down(lg){
        padding: 32px;
      }

      .shape-1 {
        position: absolute;
        top: -32%;
        right: 0;
        z-index: -1;

        @include media-breakpoint-down(md){
          display: none;
        }
      }

      .shape-2 {
        position: absolute;
        top: -22%;
        left: -13%;
        z-index: -1;

        @include media-breakpoint-down(sm){
          width: 100%;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: column;
        gap: 32px;
        padding: 0;
        margin-top: 40px;
      }
    }
    .contact-block__label {
      width: 100%;
      margin-bottom: 28px;

      &--check {
        margin-bottom: 0;

        &-text {
          font-size: .88em;
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 0;
          margin-left: 8px;
        }
      }

      .error-message {
        font-size: .88em;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 0;
        margin-left: 8px;
        color: #FF4337;
        margin-top: 4px;
      }

      .star-red {
        color: #FF4337;
      }

      & input {
        height: 40px;
        border-bottom: 1px solid #D4D4D4;
        padding: 0;
        background-color: transparent;
        border-radius: 0;
        margin-top: 12px;

        &:focus {
          box-shadow: none;
          background-color: transparent;
          border-color: #D4D4D4;
        }

        &[type='checkbox'] {
          -webkit-appearance: none;
          appearance: none;
          background-color: #fff;
          margin: 0;
          font: inherit;
          color: #000;
          width: 20px;
          height: 20px;
          border: 1px solid #007CC2;
          border-radius: 0.15em;
          display: grid;
          place-content: center;

          &::before {
            content: "";
            width: 20px;
            height: 20px;
          }

          &:checked::before {
            border: none;
            border-radius: 0.15em;
            background: #007CC2 no-repeat center url("../../assets/media/images/mark-blue.svg");
          }
        }
      }

      &-text {
        font-size: .88em;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        margin-bottom: 0;
      }
    }
    .contact-block__title {
      font-size: 1.75em;
      font-style: normal;
      font-weight: 700;
      line-height: 30px;
      margin-bottom: 40px;
    }

    .contact-block__text {

      & p {
        font-size: 1.125em;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 0;
      }

      & a {
        color: $main-color;
        font-weight: 700;
        text-decoration-line: underline;
      }
    }

    .contact-block__button {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 16px 9px 24px;
      background-color: $secondary;
      border: none;
      margin-right: -12px;
      line-height: normal;
      color: $white;
      transition: all .4s ease;
      font-weight: 500;
      margin-top: 32px;

      &:hover {
        background-color: #13588A;
      }
    }

    .form-success {
      background-color: $white;
      padding: 64px;
      border-radius: 20px;

      @include media-breakpoint-down(lg){
        padding: 32px;
      }

      & p {
        font-size: 1em;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 0;
      }
    }

    .form-error {
      background-color: $white;
      padding: 64px;
      border-radius: 20px;

      @include media-breakpoint-down(lg){
        padding: 32px;
      }

      & p {
        font-size: 1em;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 0;
        color: #FF4337;
      }
    }
</style>
